// Image mapping for campaign data and product images
import CampaignImg1 from '../assets/Images/CampaignImg1.png';
import CampaignImg2 from '../assets/Images/CampaignImg2.png';
import CampaignImg3 from '../assets/Images/CampaignImg3.png';
import CampaignDetailBanner from '../assets/Images/CampaignDetailBanner.png';
import ProjectImage1 from '../assets/Images/ProjectImage1.png';
import ProjectImage2 from '../assets/Images/ProjectImage2.png';
import ProjectImage3 from '../assets/Images/ProjectImage3.png';
import ProjectImage4 from '../assets/Images/ProjectImage4.png';
import FoodKit1 from '../assets/Images/Food-Kit1.png';
import FoodKit2 from '../assets/Images/Food-Kit2.png';
import FoodKit3 from '../assets/Images/Food-Kit3.png';
import FoodKit4 from '../assets/Images/Food-Kit4.png';
import MonthlyDonationCard1 from '../assets/Images/MonthlyDonationCard1.png';
import MonthlyDonationCard2 from '../assets/Images/MonthlyDonationCard2.png';
import MonthlyDonationCard3 from '../assets/Images/MonthlyDonationCard3.png';
import CardProfile from '../assets/Images/card-profile.png';

export const imageMapping = {
  '/src/assets/Images/CampaignImg1.png': CampaignImg1,
  '/src/assets/Images/CampaignImg2.png': CampaignImg2,
  '/src/assets/Images/CampaignImg3.png': CampaignImg3,
  '/src/assets/Images/CampaignDetailBanner.png': CampaignDetailBanner,
  '/src/assets/Images/ProjectImage1.png': ProjectImage1,
  '/src/assets/Images/ProjectImage2.png': ProjectImage2,
  '/src/assets/Images/ProjectImage3.png': ProjectImage3,
  '/src/assets/Images/ProjectImage4.png': ProjectImage4,
  '/src/assets/Images/Food-Kit1.png': FoodKit1,
  '/src/assets/Images/Food-Kit2.png': FoodKit2,
  '/src/assets/Images/Food-Kit3.png': FoodKit3,
  '/src/assets/Images/Food-Kit4.png': FoodKit4,
  '/src/assets/Images/MonthlyDonationCard1.png': MonthlyDonationCard1,
  '/src/assets/Images/MonthlyDonationCard2.png': MonthlyDonationCard2,
  '/src/assets/Images/MonthlyDonationCard3.png': MonthlyDonationCard3,
   '/src/assets/Images/card-profile.png': CardProfile,
};

// Helper function to get the correct image
export const getImageSrc = (imagePath) => {
  return imageMapping[imagePath] || imagePath;
};
